/** Textos de Talleres (FASE 4). */
const S = {
	title: "Talleres y Personalizados",
	nuevo: "Nuevo Taller",
	volver: "Volver",
	cerrar: "Cerrar",
	buscar: "Buscar taller",
	cargando: "Cargando…",
	vacio: "Sin talleres con ese filtro.",
	todos: "Todos",
	estados: { programado: "Programado", realizado: "Realizado", anulado: "Anulado", historico: "Histórico" } as { [k: string]: string },
	col: { fecha: "Fecha", taller: "Taller", lugar: "Aula y Maestra", cupo: "Inscritas", pagadas: "Pagadas", precio: "Precio", estado: "Estado" },
	// Formulario
	editar: "Editar",
	guardar: "Guardar",
	crear: "Crear Taller",
	nombre: "Nombre",
	inicio: "Inicio",
	fin: "Fin",
	curso: "Curso",
	sinCurso: "Sin curso",
	area: "Área",
	aula: "Aula",
	maestra: "Maestra",
	ninguna: "Sin asignar",
	pagoMaestra: "Pago a la maestra",
	cupoMax: "Cupo",
	precio: "Precio",
	notas: "Notas",
	textoInvitacion: "Texto de invitación",
	estado: "Estado",
	guardado: "Taller guardado.",
	creado: "Taller creado.",
	anularAviso: "Al anular se anulan los cobros sin abonos.",
	// Detalle
	inscritas: "Inscritas",
	agregar: "Agregar Alumna",
	buscarAlumna: "Nombre o código de la alumna",
	buscarBtn: "Buscar",
	seCobra: "Se cobra",
	agregarBtn: "Agregar",
	agregada: (n: string) => `${n} agregada.`,
	colAlumna: "Alumna",
	colTel: "Teléfono",
	colEstado: "Estado",
	colCobro: "Cobro",
	colAsistio: "Asistió",
	colNota: "Nota",
	pagado: "Pagado",
	porPagar: "Por pagar",
	sinCobro: "Sin cobro",
	baja: "Baja",
	bajaTitulo: (n: string) => `Baja de ${n}`,
	bajaNota: "Nota",
	bajaOk: "Alumna dada de baja.",
	sinInscritas: "Sin inscritas.",
	historicoAviso: "Taller histórico: solo lectura.",
	// Invitación
	invitacion: "Invitación por WhatsApp",
	cursosDestino: "Cursos",
	verDestinatarias: "Ver Destinatarias",
	destinatarias: (n: number) => `${n} destinatarias`,
	yaInscrita: "Ya inscrita",
	whatsappVarias: (n: number) => `WhatsApp a ${n}`,
	inscribirN: (n: number) => `Inscribir ${n}`,
	inscritasOk: (a: number, s: number) => `Inscritas ${a}` + (s ? `, sin inscribir ${s}` : "") + ".",
	motivoPrecio: "Motivo",
	precioTaller: "Precio del taller",
	elegirCurso: "Elige al menos un curso.",
	editarTaller: "Editar Taller",
	// Sesiones (multi-día)
	sesiones: "Sesiones",
	nuevaSesion: "Nueva Sesión",
	editarSesion: "Editar Sesión",
	borrarSesion: "Borrar Sesión",
	agregarSesion: "Agregar Sesión",
	borrar: "Borrar",
	sinSesiones: "Sin sesiones.",
	colFecha: "Fecha",
	colHorario: "Horario",
	colAsistencia: "Asistencia",
	fecha: "Fecha",
	entrada: "Entrada",
	salida: "Salida",
	sinHora: "Sin hora",
	sesionAgregada: "Sesión agregada.",
	sesionGuardada: "Sesión guardada.",
	sesionBorrada: "Sesión borrada.",
	asistencia: "Asistencia",
	presente: "Presente",
	ausente: "Ausente",
	colSesiones: "Sesiones",
	nSesiones: (n: number) => `${n} sesiones`,
	hora: "Hora",
	minutos: "Minutos",
	amPm: "am o pm",
	// v2 (2026-10-23)
	cursos: "Cursos",
	dias: "Días y Horarios",
	sinAula: "Sin aula",
	sinMaestra: "Sin maestra",
	calendario: "Calendario",
	mesAnterior: "Mes anterior",
	mesSiguiente: "Mes siguiente",
	todosLos: (d: string) => `Todos los ${d} del mes`,
	aplicarATodos: "Aplicar a Todos",
	tocaLosDias: "Elige los días en el calendario.",
	horaMal: "Revisa",
	quitarDia: (d: string) => `Quitar ${d}`,
	nDias: (n: number) => (n === 1 ? "1 día" : `${n} días`),
	tarifaHora: "Tarifa por Hora de la Maestra",
	tarifaHoraPh: "La de su ficha",
	faltanDias: "Elige al menos un día con entrada y salida.",
	agregarDias: "Agregar Días",
	diasAgregados: (n: number) => (n === 1 ? "Día agregado." : `${n} días agregados.`),
	pasarLista: "Pasar Lista",
	pagoMaestras: "Pago a Maestras",
	formaPago: "Forma de Pago",
	planta: "De planta",
	porHora: "Por hora",
	sinForma: "Sin definir",
	horas: "Horas",
	tarifa: "Tarifa",
	aPagar: "A Pagar",
	total: "Total",
	enviarInvitacion: (n: number) => `Enviar Invitación a ${n}`,
	crearPlantilla: "Crear Plantilla",
	horario: "Horario"
};

export default S;
